import React from "react";
import { Star } from "lucide-react";

const CTABanner = ({ onGetStarted }) => {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-900 to-black text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-repeat opacity-5"></div>
      <div className="absolute right-0 top-0 w-96 h-96 bg-green-500 rounded-full filter blur-3xl opacity-10"></div>
      <div className="absolute left-0 bottom-0 w-96 h-96 bg-green-700 rounded-full filter blur-3xl opacity-10"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Grow Organic Traffic on{" "}
            <span className="text-green-500">
              Auto-Pilot
            </span>
          </h2>

          <p className="text-lg text-gray-300 mb-10">
            Get traffic and outrank competitors with automatic SEO-optimized content generation while you sleep.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-6 mb-12">
            <button className="flex items-center justify-center px-8 py-4 rounded-full text-base font-medium bg-white text-gray-900 hover:bg-gray-100 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5">
              <img src="/images/google-logo.webp" alt="Google" className="w-5 h-5 mr-3" />
              Join with Google
            </button>

            <button 
              onClick={onGetStarted}
              className="flex items-center justify-center px-8 py-4 rounded-full text-base font-medium bg-green-500 text-white hover:bg-green-600 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5">
              Get Started for Free
            </button>
          </div>

          <div className="flex justify-center items-center">
            <div className="flex -space-x-3 mr-4">
              <img
                src="/placeholder.svg?height=48&width=48"
                alt="User"
                className="w-12 h-12 rounded-full border-2 border-white shadow-md"
              />
              <img
                src="/placeholder.svg?height=48&width=48"
                alt="User"
                className="w-12 h-12 rounded-full border-2 border-white shadow-md"
              />
              <img
                src="/placeholder.svg?height=48&width=48"
                alt="User"
                className="w-12 h-12 rounded-full border-2 border-white shadow-md"
              />
              <img
                src="/placeholder.svg?height=48&width=48"
                alt="User"
                className="w-12 h-12 rounded-full border-2 border-white shadow-md"
              />
            </div>
            <div>
              <div className="flex text-yellow-400">
                <Star className="h-5 w-5 fill-current" />
                <Star className="h-5 w-5 fill-current" />
                <Star className="h-5 w-5 fill-current" />
                <Star className="h-5 w-5 fill-current" />
                <Star className="h-5 w-5 fill-current" />
              </div>
              <p className="text-sm font-medium">50k+ Articles Created</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;

